var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Box from "../box/Box";
import Text from "./Text";
var SectionHeader = function (_a) {
    var _b = _a.as, as = _b === void 0 ? "p" : _b, icon = _a.icon, title = _a.title, children = _a.children, rest = __rest(_a, ["as", "icon", "title", "children"]);
    return (React.createElement(Box, __assign({ display: "flex", alignItems: "center", borderBottom: "2px solid", borderColor: "grays.1", py: 4 }, rest),
        icon && React.createElement(Box, { mr: 2 }, icon),
        React.createElement(Box, { flex: "1", display: "flex", justifyContent: "space-between", alignItems: "center" },
            React.createElement(Text, { fontWeight: "bold", fontSize: 3, mb: 0, lineHeight: 6, as: as }, title),
            children)));
};
SectionHeader.defaultProps = {
    mt: 3,
    mb: 3,
};
export default SectionHeader;
//# sourceMappingURL=SectionHeader.js.map